import { useAppUser } from '../admin/AppUserContext';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import MarketingLayout from '../components/MarketingLayout';

export default function HealthCheckCompletePage() {
  const { user, isLoaded } = useUser();
  const navigate = useNavigate();
  const { isSupportSession } = useAppUser();
  const [sending, setSending] = useState(true);

  useEffect(() => {
    if (!isLoaded) return;
    if (isSupportSession) {
      navigate('/dashboard', { replace: true });
      return;
    }

    // If not signed in, redirect to sign in
    if (!user) {
      navigate('/sign-in?redirect_url=' + encodeURIComponent('/health-check/complete'));
      return;
    }

    // Get health check data from sessionStorage
    const reportData = sessionStorage.getItem('healthCheckReportPending');
    if (!reportData) {
      console.warn('No health check report pending; redirecting to dashboard');
      navigate('/dashboard');
      return;
    }

    const { score, resultBand } = JSON.parse(reportData);
    sessionStorage.removeItem('healthCheckReportPending');

    // Send report
    const sendReport = async () => {
      try {
        const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';
        const baseUrl = apiUrl.replace(/\/api\/?$/, '');
        const res = await fetch(baseUrl + '/api/health-check', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: user.firstName + ' ' + user.lastName,
            email: user.emailAddresses[0].emailAddress,
            score: score,
            resultBand: resultBand,
          }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          console.error('Health check report failed', res.status, data);
        } else {
          console.log('Health check report sent successfully');
        }
      } catch (err) {
        console.error('Health check report error:', err);
      } finally {
        setSending(false);
        navigate('/dashboard');
      }
    };

    sendReport();
  }, [user, isLoaded, navigate, isSupportSession]);

  return (
    <MarketingLayout>
      <section className="public-section">
        <div className="public-container">
          <div
            className="public-card public-card--white p-8 max-w-lg mx-auto text-center"
            role="status"
            aria-live="polite"
          >
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-6" />
            <p className="public-eyebrow">Your next step, connected</p>
            <h1 className="text-3xl font-bold mb-4">
              {sending ? 'Getting your report ready.' : 'Opening your workspace.'}
            </h1>
            <p className="text-gray-600">
              {sending
                ? 'We’re preparing your health-check report for email, then taking you to your dashboard.'
                : 'Continue from your results to your company’s strategic plan.'}
            </p>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
